<template>
    <div class="panel">
        <div class="item" v-for="item in versions" :key="item.version">
            <h3>{{item.version}}</h3>

            <p v-for="(c,i) in item.content" :key="'c'+i">
                {{c.item}}
            </p>
        </div>
    </div>
</template>

<script>
    import version_zh from '../assets/common/version-log-zh.json'
    import version_en from '../assets/common/version-log-en.json'
    export default{
        name:"VersionLog",
        data(){
            return{
                versions:""
            }
        },
        created:function(){
            let lan = "zh";
            lan = this.$route.query["lan"];
            if(lan == null || lan == "undefined"){
                lan = this.getCookieByName("lan");
            }
            if(lan == "zh" || lan == null){
                this.versions = version_zh;
            }else{
                this.versions = version_en;
            }
            document.title = this.$t("message.version_log");
        }
    }
</script>

<style scoped>

    .panel{
    }

    .item{
        border-bottom: 1px #e6e9f2 solid;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 15px;
        box-sizing: border-box;
    }

    .item>h3{
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
        margin:0;
        padding: 0;
        margin-top: 14px;
        margin-bottom: 10px;
    }

    .item>p{
        color: rgba(83, 88, 104, 1);
        font-weight: 400;
        line-height: 20px;
        padding: 0;
        margin: 0;
        font-size:12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/VersionLog.vue